<template src="./RegisterMarketplaceProduto.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
import vSelect from 'vue-select';
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  components: {
    vSelect, WholeMultiselect
  },
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      products: undefined,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchProducts: "",
      categories: [{
        name: "undefined"
      }],
      categorySelected: "",
      partners: [{
        name: "undefined"
      }],
      partnerSelected: "",
      popupProductData: {
        active: undefined,
        site: undefined,
        id: undefined,
        name: undefined,
      },
      imageData: "",
      imageDataPackToSendOverHttp: "",
      clickedPhoto: false,
      invalidFields: {
        name: false,
        description: false,
        site: false,
        category: false,
        partner: false,
        photo: false,
        format: false
      },
      toggleActiveId : null
    }
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    'popupProductData.name': function(newVal) {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.name;
    },
    'popupProductData.description': function(newVal) {
      const vm = this;
      vm.invalidFields.description = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.description;
    },
    'popupProductData.site': function(newVal) {
      const vm = this;
      vm.invalidFields.site = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.site;
    },
    'categorySelected': function(newVal) {
      const vm = this;
      vm.invalidFields.category = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.category;
    },
    'partnerSelected': function(newVal) {
      const vm = this;
      vm.invalidFields.partner = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.partner;
    },
    'imageData': function(newVal) {
      const vm = this;
      vm.invalidFields.photo = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.photo;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getProducts();
      vm.getCategoriesList();
      vm.getPartnersList();
    },
    getProducts() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "marketplace/produtos?page=" + page + "&search=" + vm.searchProducts + "&include-inactives=true&size=10&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.products = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        }).finally(() => {
          vm.$vs.loading.close();
        });
    },
    getCategoriesList() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "marketplace/categoriasList?active=true", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.categories = response.data;
          }
        });
    },
    getPartnersList() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "marketplace/parceirosList?active=true", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.partners = response.data;
          }
        });
    },

    changePagination() {
      const vm = this;
      vm.getProducts();
    },
    confirmeChangeStatus(id) {
      const vm = this;
      vm.toggleActiveId = id;
      vm.$bvModal.show("modal-change-status-product");
    },
    toggleActive() {
      const vm = this;
      vm.axios
      .put(
        vm.$store.state.filooServer + "marketplace/produtos/toggle/" + vm.toggleActiveId, {}, {
          headers: {
          Authorization: vm.$session.get("bearerDefault")
          },
        }
      )
      .then(function (response) {
        if (response.status == 200) {
          vm.$bvModal.hide("modal-change-status-product");
          vm.showNotifySuccess("Operação realizada","O status do produto foi alterado com sucesso", 3000);
          vm.getProducts();
        }
      }).catch(function () {
        vm.$bvModal.hide("modal-change-status-product");
        vm.showNotifyError("Não foi possível alterar o status do produto", 6000);
      })
      .finally(function() {
        vm.$bvModal.hide("modal-change-status-product");
      });
    },
    addNewProdutoPopup() {
      const vm = this;
      vm.imageData = "";
      vm.partnerSelected = "";
      vm.categorySelected = "";
      vm.invalidFields = {
        name:false,
        description:false,
        site:false,
        category: false,
        partner: false,
        photo: false
      }
      vm.popupProductData = {
        active: true,
        id: undefined,
        name: undefined,
        description: undefined,
        site: undefined
      }
      vm.imageDataPackToSendOverHttp = undefined;
      vm.popupProduct = true;
      vm.$bvModal.show("modal-register-product");
    },
    editProdutoPopup(produto) {
      const vm = this;
      vm.invalidFields = {
        name:false,
        description:false,
        site:false,
        category: false,
        partner: false,
        photo: false
      }
      vm.partnerSelected = "";
      vm.categorySelected = produto.categoryId;
      vm.imageData = `data:image/png;base64,${ produto.photo}`;
      vm.imageDataPackToSendOverHttp = undefined;
      vm.popupProductData = {
        active: produto.active,
        id: produto.id,
        name: produto.name,
        description: produto.description,
        site: produto.site,
      };
      for(let x in vm.partners) {
        if(vm.partners[x].id == produto.partnerId) {
          vm.partnerSelected = vm.partners[x];
        }
      }
      for(let x in vm.categories) {
        if(vm.categories[x].id == produto.categoryId) {
          vm.categorySelected = vm.categories[x];
        }
      }
      vm.$bvModal.show("modal-register-product");
    },

    previewImage: function (event) {
      const vm = this;
      let format = "";
      var input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        const formData = new FormData();
        formData.append("file", input.files[0], input.files[0].name);
        format = input.files[0].type;
        vm.imageDataPackToSendOverHttp = formData;
        vm.invalidFields.format = !((format == "image/png") ||  (format == "image/jpeg")) ;
      }
    },
    addNewProduto() {
      const vm = this;
      let isInvalid = vm.validateFields();
      if(!isInvalid) {
        let pacote = {
          active: vm.popupProductData.active,
          id: vm.popupProductData.id,
          name: vm.popupProductData.name,
          description: vm.popupProductData.description,
          site: vm.popupProductData.site,
          partnerId: vm.partnerSelected.id,
          categoryId: vm.categorySelected.id,
        }
        const json = JSON.stringify(pacote);
        let packHttp = vm.imageDataPackToSendOverHttp;
        packHttp.append('dados', json);
        vm.axios
          .post(
            vm.$store.state.filooServer + "marketplace/produtos", packHttp, {
              headers: {
                Authorization: vm.$session.get("bearerDefault"),
                "Content-Type": "multipart/form-data"
              },
            }
          )
          .then(function (response) {
            if (response.status == 200) {
              vm.$bvModal.hide("modal-register-product");
              vm.showNotifySuccess("Operação realizada","Produto criado com sucesso", 3000);
              vm.getProducts();
            }
          }).catch(function() {
            vm.$bvModal.hide("modal-register-product");
            vm.showNotifyError("Não foi possível criar um novo produto", 6000);
          })
          .finally(function(){
            vm.$bvModal.hide("modal-register-product");
          });
      }
    },
    editProduto() {
      const vm = this;
      let isInvalid = vm.validateFields();
      if(!isInvalid) {
        let pacote = {
          active: vm.popupProductData.active,
          id: vm.popupProductData.id,
          name: vm.popupProductData.name,
          description: vm.popupProductData.description,
          site: vm.popupProductData.site,
          partnerId: vm.partnerSelected.id,
          categoryId: vm.categorySelected.id,
        }
        const json = JSON.stringify(pacote);
        let packHttp = vm.imageDataPackToSendOverHttp;

        if(packHttp === undefined) {
          packHttp = new FormData();
        }
        packHttp.append('dados', json);

        vm.axios
          .put(
            vm.$store.state.filooServer + "marketplace/produtos", packHttp, {
              headers: {
                Authorization: vm.$session.get("bearerDefault")
              },
            }
          )
          .then(function (response) {
            if (response.status == 200) {
              vm.$bvModal.hide("modal-register-product");
              vm.showNotifySuccess("Operação realizada","Produto alterado com sucesso", 3000);
              vm.getProducts();
            }
          }).catch(function() {
            vm.$bvModal.hide("modal-register-product");
            vm.showNotifyError("Não foi possível alterar o produto", 6000);
          })
          .finally(function(){
            vm.$bvModal.hide("modal-register-product");
          });
      }
    },
    changeSearchProdutos() {
      const vm = this;
      vm.currentx = 1;
      vm.$vs.loading();
      vm.getProducts();
    },
    validateFields() {
      const vm = this;
      let invalid = vm.invalidFields;
      invalid.name = vm.testNullUndefinedEmpty(vm.popupProductData.name);
      invalid.description = vm.testNullUndefinedEmpty(vm.popupProductData.description);
      invalid.site = vm.testNullUndefinedEmpty(vm.popupProductData.site);
      invalid.category = vm.testNullUndefinedEmpty(vm.categorySelected);
      invalid.partner = vm.testNullUndefinedEmpty(vm.partnerSelected);
      invalid.photo = vm.testNullUndefinedEmpty(vm.imageData);

      return (invalid.name || invalid.description || invalid.site
      || invalid.category || invalid.partner || invalid.photo || vm.invalidFields.format);
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" src="./RegisterMarketplaceProduto.scss">
</style>
